export default {
  date: 'April 18, 2024',
  title: 'Adding a Tesla to floor plans with a garage!',
  description: 'We have incorporated cars into the garage layouts, expanding the possibilities of visualizing future homes.',
  id: 'Adding-a-Tesla-to-floor-plans-with-a-garage',
  jsx: () => (
    <div class='novelty__text'>
      <p>We have incorporated cars into the garage layouts, expanding the possibilities of visualizing future homes.</p>
      <p>
        This is not just an addition to the layout - it's about creating a more realistic picture of life in a new house. Now, when potential buyers browse house plans, they can not only see spacious rooms and functional relaxation areas but also envision their car, comfortably parked in the garage.
      </p>
      <p>
        This detail adds an important aspect of reality and coziness, allowing clients not just to consider options but also to emotionally connect with their future home. Imagine how easily you can envision yourself in this space, feeling at home, already seeing your car, ready for adventures, in
        the garage.
      </p>
      <p>
        Thanks to this level of visualization, clients can easily picture themselves in the new space, making the process of choosing a home more engaging and interactive. The resulting impression reinforces confidence in the choice and makes the anticipation of moving into a new home even more
        exciting.
      </p>
    </div>
  ),
  thumb: 'news/13.webp',
};
